import React from "react";

const Portfoliotopsection = ({ title, description }) => {
  return (
    <section className="portfolio-hero-section d-flex align-items-center">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 hero-content">
            <span className="portfolio-hero-subtitle">{title}</span>

            <div className="hedding process-underline-flex">
              <div className="process-underline"></div>
              <div className="process-underline"></div>
            </div>

            <p className="portfolio-title mb-0">{description}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfoliotopsection;
